import React, { useState } from 'react'
import { useTCodes } from 'hooks'
import { useIsSmallScreen } from 'packages/core'
import { useTranslation } from 'react-i18next'
import { Box } from '@mui/material'
import { TableGrid } from 'components'
import { Pagination, ThresholdSearchInput } from 'packages/eid-ui'

const take = 10

const TCodesList = ({ resourceId, differentiationValueId }) => {
    const isSmallScreen = useIsSmallScreen()

    const { t } = useTranslation()
    const [page, setPage] = React.useState(1)
    const [perPageItems, setPerPageItems] = useState(take)
    const [searchKey, setSearchKey] = useState('')

    const handlePageChange = (_, value) => {
        setPage(value)
    }
    const handlePageSelection = (value) => {
        setPage(value)
    }
    const handleItemsPerPageChange = (value) => {
        setPage(1)
        setPerPageItems(value)
    }

    const handleSearchChange = (value) => {
        setPage(1)
        setSearchKey(value)
    }

    const { data } = useTCodes(
        resourceId,
        differentiationValueId,
        (page - 1) * perPageItems,
        perPageItems,
        searchKey && encodeURIComponent(searchKey),
    )
    const list = data ? data.data : undefined

    const isInitialLoading = !Boolean(data)

    const numberOfPages = data ? Math.ceil(data.totalCount / perPageItems) : 0

    const attributes = [
        {
            label: t('Common_FriendlyName'),
            name: 'friendlyName',
        },
        {
            label: t('Common_Description'),
            name: 'description',
        },
        {
            label: t('Common_RightTypeName'),
            name: 'rightTypeName',
        },
        {
            label: t('Common_ResourceSystem'),
            name: 'resourceSystemName',
        },
    ]

    return (
        <>
            <Box
                width="100%"
                display="flex"
                alignItems="center"
                justifyContent="flex-start"
                padding="16px 32px 16px 32px"
                style={{ backgroundColor: '#ebebed' }}
            >
                <Box width={!isSmallScreen ? '308px' : '200px'}>
                    <ThresholdSearchInput
                        placeholder={'Common_Search'}
                        handleSearch={handleSearchChange}
                    />
                </Box>
            </Box>
            <TableGrid
                loading={isInitialLoading}
                data={list}
                attributes={attributes}
            />

            {!isInitialLoading && (
                <Box
                    padding={!isSmallScreen ? '20px 0px' : '16px'}
                    display="flex"
                    alignItems="center"
                    justifyContent="center"
                >
                    <Pagination
                        count={numberOfPages}
                        page={page}
                        size={!isSmallScreen ? 'large' : 'small'}
                        onChange={handlePageChange}
                        totalCount={data?.totalCount}
                        onPageSelection={handlePageSelection}
                        itemsPerPage={perPageItems}
                        onItemsPerPageChange={handleItemsPerPageChange}
                        showPageSelection={true}
                        showItemsPerPageSelection
                        showCountStat
                    />
                </Box>
            )}
        </>
    )
}

export default TCodesList
